export function createAuthApi(client) {
    return {
        register(username, password, displayName, email, role) {
            return client.post('/api/auth/register', { username, password, displayName, email, role });
        },
        login(username, password) {
            return client.post('/api/auth/login', { username, password });
        },
        refresh(refreshToken) {
            return client.post('/api/auth/refresh', { refreshToken });
        },
        logout() {
            return client.post('/api/auth/logout');
        },
        me() {
            return client.get('/api/auth/me');
        },
        updateProfile(data) {
            return client.put('/api/auth/me', data);
        },
        listUsers() {
            return client.get('/api/auth/users');
        },
        createUser(data) {
            return client.post('/api/auth/users', data);
        },
        updateUser(id, data) {
            return client.put(`/api/auth/users/${id}`, data);
        },
        deleteUser(id) {
            return client.del(`/api/auth/users/${id}`);
        },
        toggleUserActive(id) {
            return client.post(`/api/auth/users/${id}/toggle-active`);
        },
    };
}
//# sourceMappingURL=auth.js.map